import type { WorkOrderChangeObjectItem, WorkOrderObjectData } from 'gql/graphql';

export type WorkOrderFilterType = {
    objectId?: number;
    subObjectId?: number;
    level?: {
        label: string;
        value: WorkOrderFilterLevelEnum;
    };
};

export enum WorkOrderFilterLevelEnum {
    TOTALS,
    GUARANTEED_VOLUME,
}

export interface IWorkOrderFilterFormProps {
    constructionTypeId: number;
    defaultValues: WorkOrderFilterType;
    onChange: (filters: WorkOrderFilterType) => void;
    workOrderObjects: WorkOrderObjectData[] | WorkOrderChangeObjectItem[] | null | undefined;
    onActsKc2AnalyticsOpen?: () => void;
    isActsKc2AnalyticsEnabled?: boolean;
    actsKc2AnalyticsButtonTooltip?: string;
}

export const levelItems = [
    {
        label: 'Гарантированный объем',
        value: WorkOrderFilterLevelEnum.GUARANTEED_VOLUME,
    },
    {
        label: 'Итоги',
        value: WorkOrderFilterLevelEnum.TOTALS,
    },
];
